import ViewListIcon from '@mui/icons-material/ViewList';
import CalculateIcon from '@mui/icons-material/Calculate';
import ArticleIcon from '@mui/icons-material/Article';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../../components/home/Header';
import About from '../about';
import PrimaryButton from '../../components/common/button/PrimaryButton';

function Home() {
  const navigate = useNavigate();

  const handleFee = () => {
    navigate('/forms/fees');
  };

  const handleDocs = () => {
    navigate('/forms/docs');
  };

  const handleTitle = () => {
    navigate('/forms/lien-check');
  };

  useEffect(() => {
    const handleScroll = () => {
      const homeSection = document.getElementById('home');
      const aboutSection = document.getElementById('about');
      const scrollPosition = window.scrollY + window.innerHeight / 2;

      if (aboutSection && scrollPosition >= aboutSection.offsetTop) {
        if (window.location.hash !== '#about') {
          window.history.replaceState(null, '', '#about');
        }
      } else if (homeSection && scrollPosition < aboutSection.offsetTop) {
        if (window.location.hash !== '#home') {
          window.history.replaceState(null, '', '#home');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className='py-4'>
      <Header />

      <div className="px-8">
        <div className="rounded-2xl">
          <div className="w-full">
            <div id="home" style={{ backgroundColor: "#F6FEF9" }} className="border-t-2 rounded-b-2xl overflow-hidden">
              <div
                className="flex flex-col items-center mt-20"
                style={{
                  backgroundImage: 'url(/vectors/home.png)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  width: '100%',
                  height: '75vh',
                }}
              >
                <div className="flex flex-col w-[45%] text-center px-4 relative z-10">
                  <div className="text-6xl font-bold mb-6">
                    Get It Right The First Time
                  </div>

                  <div className="text-gray-700 text-lg item-center mb-8">
                   DMV Navigator, by CULS Lending Solutions, saves time by simplifying and automating how you gather the right data and documents to calculate vehicle taxes and registration fees nationwide.
                  </div>

                  <div>
                    <PrimaryButton
                      id="get-started-btn"
                      text="Get Started"
                      onClick={() => window.open('https://culoansource.formstack.com/forms/lendingsolutions_interest', '_blank', 'noopener,noreferrer')}
                    />
                  </div>
                </div>

                <div className="relative top-28 shadow-2xl">
                  <img className="h-[520px] w-[770px]" src="/login2.png" alt="" />
                </div>
              </div>
            </div>

            <div className="py-20 px-4 flex justify-center w-full mb-16">
              <div className="flex items-center w-full">
                <div className="flex-grow border-t border-gray-200" />

                <div className="mx-12 text-center text-gray-800 font-medium text-2xl whitespace-nowrap">
                  Collaborating with Financial Institutions Nationwide
                </div>

                <div className="flex-grow border-t border-gray-200" />
              </div>
            </div>

            <div className="flex flex-col items-center mb-6">
              <div className="text-5xl font-bold mb-4">
                DMV Navigator Features
              </div>

              <div className="text-gray-700">
                Your One-Stop Solution for Seamless, Compliant Vehicle Transactions.
              </div>
            </div>

            <div className="border rounded-xl mb-8 box-shadow">
              <div className="flex flex-row w-full overflow-hidden">
                <div className="flex flex-col w-1/2 p-14">
                  <div className="text-3xl font-bold mb-8">
                    Fees
                  </div>

                  <div className="text-lg text-gray-700 mb-6">
                    DMV Navigator takes the mystery out of vehicle fees by compiling all the costs you need to know. No more hidden charges or surprise fees; just
                    clear, accurate, and up-to-date information to keep your vehicle transactions on track
                  </div>

                  <div>
                    <button
                      onClick={handleFee}
                      className="border border-green-800 px-7 py-3 rounded-lg text-green-800 hover:bg-green-800 hover:text-white"
                    >
                      Calculate Fees
                    </button>
                  </div>
                </div>

                <div className="w-1/2 relative pt-12 pl-2">
                  <img className="h-[520px] w-[1100px] rounded-lg" src="/fee.png" alt="" />
                </div>
              </div>
            </div>

            <div className="flex flex-row w-full mb-20 gap-6">
              <div className="w-1/2 border overflow-hidden rounded-xl pt-12 px-8 box-shadow">
                <div className="text-3xl font-bold mb-8">
                  Documents
                </div>

                <div className="text-lg text-gray-700 mb-6">
                  DMV Navigator simplifies the entire paperwork process for vehicle transactions, gathering and pre-filling all required forms in one convenient 
                  place. Say goodbye to time-consuming searches and penalties; everything you need is clear, accessible, and always up-to-date.
                </div>

                <div>
                  <button
                    onClick={handleDocs}
                    className="border border-green-800 px-7 py-3 rounded-lg text-green-800 hover:bg-green-800 hover:text-white"
                  >
                    Check Document Requirements
                  </button>
                </div>

                <div className="relative top-16">
                  <img className="h-[400px] w-[900px] rounded-lg" src="/doc_output.png" alt="" />
                </div>
              </div>

              <div className="w-1/2 border overflow-hidden rounded-xl pt-12 px-8 box-shadow">
                <div className="text-3xl font-bold mb-8">Lien & Title Check</div>
                <div className="text-lg text-gray-700 mb-6">
                  DMV Navigator provides robust support for title and lien processes by ensuring collateral is properly secured and verified. With thorough safety and soundness checks, you can confidently mitigate risk at every step, from lien placement to release.
                </div>

                <div>
                  <button
                    onClick={handleTitle}
                    className="border border-green-800 px-7 py-3 rounded-lg text-green-800 hover:bg-green-800 hover:text-white"
                  >
                    Check Lien & Title
                  </button>
                </div>

                <div className="relative top-16">
                  <img className="h-[400px] w-[900px] rounded-lg" src="/title_check.png" alt="Lien and Title Output" />
                </div>
              </div>
            </div>

            <div style={{ backgroundColor: "#F4F8F5" }} className="flex justify-around w-full rounded-xl p-20 mb-4">
              <div className="text-center w-56">
                <div className="flex items-center justify-center w-16 h-16 bg-green-800 rounded-full mx-auto mb-2">
                  <ViewListIcon style={{ color: 'white' }} />
                </div>

                <div className="text-gray-700">11,000+ Jurisdictions of Comprehensive fee & Tax data</div>
              </div>
              <div className="text-center w-56">
                <div className="flex items-center justify-center w-16 h-16 bg-green-800 rounded-full mx-auto mb-2">
                  <ArticleIcon style={{ color: 'white' }} />
                </div>

                <div className="text-gray-700">
                  Extensive Library of DMV Forms and Documentation
                </div>
              </div>

              <div className="text-center w-56">
                <div className="flex items-center justify-center w-16 h-16 bg-green-800 rounded-full mx-auto mb-2">
                  <CalculateIcon style={{ color: 'white' }} />
                </div>

                <div className="text-gray-700">Precise Taxable Value Calculations</div>
              </div>
            </div>

            <div id="about">
              <About />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;